'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var debug = require('debug');

var log = debug('libp2p-ping');
log.error = debug('libp2p-ping:error');

var errCode = require('err-code');

var crypto = require('libp2p-crypto');

var pipe = require('it-pipe');

var _require = require('it-buffer'),
    toBuffer = _require.toBuffer;

var _require2 = require('streaming-iterables'),
    collect = _require2.collect,
    take = _require2.take;

var _require3 = require('./constants'),
    PROTOCOL = _require3.PROTOCOL,
    PING_LENGTH = _require3.PING_LENGTH;
/**
 * Ping a given peer and wait for its response, getting the operation latency.
 * @param {Libp2p} node
 * @param {PeerInfo} peer
 * @returns {Promise<Number>}
 */


function ping(_x, _x2) {
  return _ping.apply(this, arguments);
}
/**
 * Subscribe ping protocol handler.
 * @param {Libp2p} node
 */


function _ping() {
  _ping = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node, peer) {
    var _yield$node$dialProto, stream, start, data, _yield$pipe, _yield$pipe2, result, end;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            log('dialing %s to %s', PROTOCOL, peer.id.toB58String());
            _context.next = 3;
            return node.dialProtocol(peer, PROTOCOL);

          case 3:
            _yield$node$dialProto = _context.sent;
            stream = _yield$node$dialProto.stream;
            start = new Date();
            data = crypto.randomBytes(PING_LENGTH);
            _context.next = 9;
            return pipe([data], stream, function (stream) {
              return take(1, stream);
            }, toBuffer, collect);

          case 9:
            _yield$pipe = _context.sent;
            _yield$pipe2 = _slicedToArray(_yield$pipe, 1);
            result = _yield$pipe2[0];
            end = Date.now();

            if (data.equals(result)) {
              _context.next = 15;
              break;
            }

            throw errCode(new Error('Received wrong ping ack'), 'ERR_WRONG_PING_ACK');

          case 15:
            return _context.abrupt("return", end - start);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _ping.apply(this, arguments);
}

function mount(node) {
  node.handle(PROTOCOL, function (_ref) {
    var stream = _ref.stream;
    return pipe(stream, stream);
  });
}
/**
 * Unsubscribe ping protocol handler.
 * @param {Libp2p} node
 */


function unmount(node) {
  node.unhandle(PROTOCOL);
}

exports = module.exports = ping;
exports.mount = mount;
exports.unmount = unmount;